<template>
	<el-row :gutter="10" style="background: #f0f3f5;height:100%;">
		<el-col :span="5" class="left_box">
			<el-card style="border-right: 1px solid #ebeef5; height: 100%;background: #ffffff;">
				<el-input v-model="search" placeholder="输入云手机名称或ID搜索" clearable @input="Get_search_Phones" />
				<div class="select-all">
					<el-checkbox :model-value="selectAllChecked" :indeterminate="selectIndeterminate"
						@change="toggleSelectAll">
						全选 ({{ selectedDevicesCountInCurrentType }}/{{ phoneList.length }})
					</el-checkbox>
					<el-button type="primary" size="small" :disabled="selectedDevicesCountInCurrentType < 2"
						@click="batchRenew">
						批量续费
					</el-button>
				</div>
				<div v-loading="loading" style="display: flex; flex-direction: column; height: 70vh;">
					<el-scrollbar style="flex: 1; min-height: 0;padding-right: 15px;">
						<el-card v-for="phone in phoneList" :key="phone.id" shadow="hover" class="mt-3"
							style="position: relative; min-height: 80px; padding:10px;border-radius: 15px; cursor: pointer;"
							@click="selectPhone(phone)">
							<div style="width:100%;display: flex;justify-content: space-between;align-items: center;">
								<div style="display: flex;align-items: center;">
									<el-checkbox v-model="phone.checked" @click="selectPhone(phone)"></el-checkbox>
									<div style="font-weight: bold; margin-left: 8px;">
										{{ phone.instance_name || `云机${phone.id}` }}
									</div>
								</div>
								<div>
									<el-button type="primary" size="small"
										:disabled="selectedDevicesCountInCurrentType > 1 || (selectedDevicesCountInCurrentType === 1 && !phone.checked)"
										@click.stop="renewPhone(phone)">续费</el-button>
								</div>
							</div>
							<div
								style="display: flex;justify-content: space-between;width: 100%;align-items: center;margin-bottom: 4px;">
								<div style="color: #909399;">ID: {{ phone.instances.name }}</div>
							</div>
							<div style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
								<div :style="{ color: getRemainingDaysColor(phone) }">
									<CountdownComponent :expireTime="phone.expire_time" :is_trial="phone.is_trial" />
								</div>
							</div>
						</el-card>
					</el-scrollbar>
				</div>
			</el-card>
		</el-col>
		<el-col :span="19" style="background: #f0f3f5;padding:0">
			<el-card style="border-left: 1px solid #ebeef5; height: 100%;background: #ffffff">
				<div class="top-right-buttons" style="margin-bottom: 10px;">
					<el-checkbox :model-value="selectAllChecked_right" :indeterminate="selectIndeterminate_right"
						@change="toggleSelectAll_right">
						全选 ({{ selectedDevicesCountInCurrentType2 }}/{{ phoneList.length }})
					</el-checkbox>
					<div>
						<el-popover placement="bottom" trigger="click" popper-style="padding:0;">
							<template #reference>
								<el-button type="primary">批量操作</el-button>
							</template>
							<div class="fun_options">
								<p @click="restart_All_Phone">重启</p>
								<p @click="reset_All_Phone">重置</p>
								<p @click="shutdown_All_Phone">一键新机</p>
								<p @click="android_classify_phone">更换机型</p>
							</div>
						</el-popover>
						<el-button @click.stop="router.push('/groupControl')">云机群控</el-button>
					</div>
				</div>
				<el-scrollbar height="78vh">
					<el-row class="main_container">
						<el-col v-for="phone in previewPhoneList" :key="phone.id" :span="2">
							<div class="compact-rectangle">
								<div
									style="display: flex;flex-direction: column;height: 100%;width:100%;position: relative;padding-bottom: 20px;">
									<div style="display: flex;align-items: center;justify-content: space-between;width:100%;height: 20px;"
										@click.stop="selectPhone_right(phone)">
										<el-checkbox v-model="phone.checked"
											@click="selectPhone_right(phone)"></el-checkbox>
										<div class="phone_name_box" @click.stop>
											<el-icon style="margin: 0 10px;" @click="edit_phone_name(phone)">
												<Edit />
											</el-icon>
											<input v-if="phone.edit_name_checked" v-model="phone.instance_name"
												:class="`phoneInput_${phone.id}`"
												@blur="enter_edit_phone_name(phone,'blur')"
												@keydown.enter="enter_edit_phone_name(phone,'enter')" />
											<el-popover :content="phone.instance_name" placement="top"
												popper-style="padding:0;width:initial;min-width:initial;">
												<template #reference>
													<span
														style="display: inline-block; width: 72%;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
														v-if="!phone.edit_name_checked">{{ phone.instance_name || `云机${phone.id}` }}</span>
												</template>
											</el-popover>
										</div>
									</div>
									<div class="compact-image-container" v-loading="phone.screen_shot_loading"
										element-loading-text="重启中,请稍等" element-loading-background="rgba(0, 0, 0, 0.5)"
										@click="showPhoneOverlay(phone)">
										<img v-if="phone.preview_image" style="max-width: 100%; max-height: 100%;"
											:src="phone.preview_image" alt="预览图" @error="handleImageError">
										<img v-else src="@/assets/phone_no_bg2.png" alt="Logo"
											style="max-width: 100%; max-height: 100%;">
									</div>
									<div class="phone-android-version-view">
										<div><img src="@/assets/android-head_flat.png" />{{phone.image_tag}}</div>
										<div>{{phone.instances?.real_phone_template?.brand}}</div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="compact-rectangle" @click="addNewPhone">
								<div class="compact-image-container">
									<div
										style="display: flex;flex-direction: column;align-items:center;align-content: center;">
										<el-icon :size="20">
											<CirclePlus />
										</el-icon>
										<span>新增云手机</span>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</el-scrollbar>
			</el-card>
		</el-col>
		<!-- 群体更换机型的弹窗 -->
		<el-dialog v-model="change_phone_model_visible" width="500" title="设备列表">
			<div class="android-tabs-header">
				<div v-for="(item, index) in android_classify_phone_list" :key="index" class="android-tab-item"
					:class="{ active: current_android_version == item.android_version }"
					@click="change_phone_model_dialog_show(item)">Android {{ item.android_version }}
				</div>
			</div>
			<el-table ref="phoneTableRef" :data="current_android_phone_tableData" style="width: 100%"
				@selection-change="handleSelectionChange" :row-key="getRowKey" :row-class-name="getRowClass" :cell-class-name="getCellClass">
				<el-table-column type="selection" width="55" :selectable="checkSelectable" />
				<el-table-column property="instance_name" label="云机名称"></el-table-column>
				<el-table-column property="instances.real_phone_template.brand" label="品牌"></el-table-column>
				<el-table-column property="instances.real_phone_template.model" label="机型"></el-table-column>
			</el-table>
			<div style="margin-top: 10px;" class="flex_between_center">
				<label style="white-space: nowrap;margin-right: 10px;">产品品牌</label>
				<el-select v-model="select_brand_value" placeholder="请选择产品品牌" @change="select_brands">
					<el-option v-for="item in phone_type_list" :key="item.brand" :label="item.brand"
						:value="item.brand" />
				</el-select>
				<label style="white-space: nowrap;margin:0 10px;">云机机型</label>
				<el-select v-model="select_model_value" placeholder="请选择云机机型" :disabled="!select_brand_value">
					<el-option v-for="item in select_model_list" :key="item.id" :label="item.model" :value="item.id" />
				</el-select>
			</div>
			<div style="text-align: left;"><el-checkbox label="重置云机数据" v-model="reset_phone_data_checked" /></div>
			<template #footer>
				<div class="dialog-footer">
					<el-button type="primary" @click="check_All_phone_type">更换机型</el-button>
					<el-button @click="change_phone_model_visible = false">取消</el-button>
				</div>
			</template>
		</el-dialog>
		<transition name="slide-fade">
			<div v-show="showOverlay" class="overlay-mask">
				<div class="overlay-container" :style="{ width: elementWidth}">
					<el-icon class="close-icon" @click="closeOverlay(false)">
						<Close />
					</el-icon>
					<div class="overlay-content">
						<input id="ime" ref="imeRef" style="position:absolute; top:0px;opacity: 0;"
							:readOnly="!store.state.Phone_Local_keyboard_flag" />
						<input id="ime2" ref="imeRef2" style="position:absolute; top:0px;opacity: 0;"
							:readOnly="store.state.Phone_Local_keyboard_flag" />

						<div v-if="currentPhone.id" class="phone-display" v-loading="restartPhone_loading"
							:element-loading-text="restartPhone_loading_text"
							element-loading-background="rgba(0, 0, 0, 0.7)" @mouseover="hoverdada">
							<div @click="imeRef_focus"
								:id="`phone-display-${currentPhone.instances.machine.ip}:${currentPhone.instances.adb_port}`"
								class="master-phone-view" style="padding-top: 15%;">
							</div>
							<el-button v-if="showInfoToggle" class="info-toggle-btn" type="primary" circle
								@click="showInfoPanel = !showInfoPanel">
								<el-icon>
									<component :is="showInfoPanel ? ArrowRight : ArrowLeft" />
								</el-icon>
							</el-button>
						</div>
						<div class="phone-info" :class="{ 'hidden': !showInfoPanel }"
							:style="{ display:elementWidthflag==true?'block':'none' }">
							<h3 style="margin-top: 0">云机详细信息</h3>
							<div class="info-container">
								<div class="info-row">
									<span class="info-label">云机名称</span>
									<span
										class="info-value">{{ currentPhone.instance_name || `云机${currentPhone.id}` }}</span>
								</div>
								<div class="info-row">
									<span class="info-label">云机品牌机型</span>
									<span
										class="info-value">{{ currentPhone.instances?.real_phone_template?.brand }}&nbsp;{{currentPhone.instances?.real_phone_template?.model}}</span>
								</div>
								<div class="info-row">
									<span class="info-label">云机ID</span>
									<span class="info-value">{{ currentPhone.instances?.name || '-' }}</span>
								</div>
								<div class="info-row">
									<span class="info-label">到期时间</span>
									<span class="info-value">{{ formatDate(currentPhone.expire_time) }}</span>
								</div>
								<div class="info-row">
									<span class="info-label">剩余天数</span>
									<span class="info-value">
										<CountdownComponent :expireTime="currentPhone.expire_time"
											:is_trial="currentPhone.is_trial" />
									</span>
								</div>
								<div class="info-row">
									<span class="info-label">运行状态</span>
									<span class="info-value">
										<span class="status-tag"
											:class="currentPhone.status === 1 ? 'running' : 'stopped'">
											{{ currentPhone.status === 1 ? '运行中' : '已停止' }}
										</span>
									</span>
								</div>
								<div class="info-row">
									<span class="info-label">配置信息</span>
									<span class="info-value">
										{{ currentPhone.instances?.cpu_cores || '-' }}核
										{{ (currentPhone.instances?.memory / 1024).toFixed(0) || 0 }}G运存
										{{ currentPhone.instances?.storage || '-' }}G存储
									</span>
								</div>
								<div class="action-row">
									<el-popover ref="phone_type_popoverRef" placement="left" trigger="click"
										width="auto">
										<template #reference>
											<el-button plain round v-if="currentPhone.instances?.is_realphone==1"
												type="primary" @click="change_phone_type('single')">更换机型</el-button>
										</template>
										<template #default>
											<el-cascader-panel v-model="cascader_value" :options="phone_type_list"
												:props="props" @change="check_phone_type" />
										</template>
									</el-popover>
									<el-button plain round type="warning" @click="restartPhone">重启</el-button>
									<el-button plain round type="danger" @click="resetPhone">重置</el-button>
									<el-button plain round type="success" @click="shutdownPhone">一键新机</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</el-row>
</template>

<script setup lang="ts">
	type Machine = {
		id : number;
		ip : string;
		cpu : string;
		cpu_core : number;
		memory : number;
		volume : number;
		status : number;
		created_at : string;
		updated_at : string;
		mac_addr : string;
		volume_device : string;
	};
	type Real_phone_template = {
		brand : string;
		model : string;
	}
	type Instance = {
		id : number;
		machine_id : number;
		mac : string;
		ip : string;
		product_id : number;
		package_id : number;
		created_at : string;
		updated_at : string;
		status : number;
		is_realphone : number;
		adb_port : number;
		adb_address : string;
		height : number;
		width : number;
		image : string;
		image_tag : string;
		index : number;
		state : number;
		cpu_cores : number;
		memory : number;
		storage : number;
		name : string;
		machine : Machine;
		real_phone_template : Real_phone_template;
	};

	type Phone = {
		id : number;
		user_id : string;
		instance_id : number;
		start_time : string;
		expire_time : string;
		status : number;
		created_at : string;
		updated_at : string;
		order_id : number;
		image : string;
		image_tag : string;
		auto_renew : number;
		screen_shot : string;
		instance_name : string;
		instances : Instance;
		is_trial ?: number;
		state : number;
		checked ?: boolean;
		edit_name_checked ?: boolean;
		preview_image : string;
		screen_shot_loading ?: boolean;
	};

	// 修复点3：定义 PhoneBrand 和 ModelOption 类型，明确结构
	interface ModelOption {
		id : number | string;
		model : string;
		[key : string] : any; // 兼容其他属性
	}

	interface PhoneBrand {
		brand : string;
		models : ModelOption[]; // 明确 models 是 ModelOption 数组
	}
	// 新增：安卓版本分组类型
	interface AndroidVersionGroup {
		android_version : string;
		phones_arr : Phone[];
	}
	import { useRouter } from 'vue-router';
	const router = useRouter();
	import '../style/app.css';
	import defaultImage from '@/assets/phone_no_bg2.png';
	import { ref, Ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
	import { Close, CirclePlus, ArrowRight, ArrowLeft, Edit } from '@element-plus/icons-vue'; // 补充导入 Edit 图标
	import { StreamClientScrcpy } from '@/app/googDevice/client/StreamClientScrcpy';
	import CountdownComponent from '@/components/CountdownComponent.vue';
	import { KeyInputHandler, type KeyEventListener } from '@/app/googDevice/KeyInputHandler';
	import { CommandControlMessage } from '@/app/controlMessage/CommandControlMessage'
	import { ElMessage, ElMessageBox } from 'element-plus';
	import request from '@/utils';
	import { useStore } from 'vuex';
	import type { PopoverInstance } from 'element-plus'
	const phone_type_popoverRef = ref<PopoverInstance>()
	const store = useStore();
	const elementWidth = ref('auto');
	const elementWidthflag = ref(true);
	const search = ref('');
	const viewMode = ref('card');
	const showOverlay = ref(false);
	const showInfoPanel = ref(true);
	const windowWidth = ref(window.innerWidth);
	const loading = ref(false);
	const restartPhone_loading = ref(false);
	const restartPhone_loading_text = ref('云手机重启中,请稍等');
	const phoneList = ref<Phone[]>([]);
	const previewPhoneList = ref<Phone[]>([]);
	const No_change_phone_list = ref<Phone[]>([]);
	const filter_phone_type_list = ref<Phone[]>([]);
	const Phone_selectedMap = ref(new Map<number, boolean>());
	const Phone_selectedMap_right = ref(new Map<number, boolean>());
	const currentPhone = ref<Phone>({} as Phone);
	const hash = location.hash.replace(/^#!/, '');
	const parsedQuery = new URLSearchParams(hash);
	const selectAllChecked = ref(false);
	const selectAllChecked_right = ref(false);
	const selectIndeterminate = ref(false);
	const selectIndeterminate_right = ref(false);
	const close_out : any = ref(null);
	const enter_change_flag : any = ref(false);
	const select_brand_value = ref('');//群体更改云机弹窗选中的品牌
	const select_model_value = ref(''); //群体更改云机弹窗选中的机型
	const select_model_list = ref<ModelOption[]>([]);
	const android_classify_phone_list = ref<AndroidVersionGroup[]>([]);
	const android_selectedPhones = ref<Phone[]>([]); //更换机型弹窗根据安卓版本选中的云手机列表数据
	const change_phone_model_visible : any = ref(false); //群体更改云手机机型弹窗开关
	const current_android_version : any = ref(null); //当前群体更改云机机型弹窗时当前的tabs安卓版本
	const phoneTableRef = ref<any>(null); //当前更改云机机型弹窗里table ref
	const current_android_phone_tableData : any = ref(false);
	const reset_phone_data_checked : any = ref(false);
	const warningMessage : any = ref(null);
	const ws : Ref<WebSocket | null> = ref(null);
	const StreamClientScrcpy_start : Ref<StreamClientScrcpy | null> = ref(null);
	const cascader_value = ref([]);
	const loading_phone_info : any = ref(null);
	const phone_type_list = ref<PhoneBrand[]>([]); // 现在使用定义好的 PhoneBrand 类型
	const phone_type_cascader_show = ref(false);
	const fetchPhoneList_Interval = ref<NodeJS.Timeout | null>(null)
	const IsEnglish_Or_Chinese_input = ref(true);
	const props = { label: 'model', value: 'id', children: 'models' };
	const selectedDevicesCountInCurrentType = computed(() => phoneList.value.filter(phone => phone.checked).length);
	const selectedDevicesCountInCurrentType2 = computed(() => previewPhoneList.value.filter(phone => phone.checked).length);
	const handleImageError = (e : any) => {
		const target = e.target as HTMLImageElement;
		target.src = defaultImage;
	};
	const filteredDevices = computed(() => phoneList.value);
	const toggleSelectAll = (val : boolean) => {
		phoneList.value.forEach(phone => {
			phone.checked = val;
			Phone_selectedMap.value.set(phone.id, val);
		});
		selectAllChecked.value = val;
		selectIndeterminate.value = false;
	};
	const toggleSelectAll_right = (val : boolean) => {
		previewPhoneList.value.forEach(phone => {
			phone.checked = val;
			Phone_selectedMap_right.value.set(phone.id, val);
		});
		selectIndeterminate_right.value = false;
		selectAllChecked_right.value = val;
	};

	watch(phoneList, (newVal) => {
		if (newVal.length === 0) {
			selectAllChecked.value = false;
			selectIndeterminate.value = false;
			return;
		}
		const checkedCount = newVal.filter(phone => phone.checked).length;
		selectAllChecked.value = checkedCount === newVal.length;
		selectIndeterminate.value = checkedCount > 0 && checkedCount < newVal.length;
	}, { deep: true });

	watch(previewPhoneList, (newVal) => {
		if (newVal.length === 0) {
			selectAllChecked_right.value = false;
			selectIndeterminate_right.value = false;
			return;
		}
		const checkedCount = newVal.filter(phone => phone.checked).length;
		selectAllChecked_right.value = checkedCount === newVal.length;
		selectIndeterminate_right.value = checkedCount > 0 && checkedCount < newVal.length;
	}, { deep: true });

	const Get_search_Phones = () => {
		phoneList.value = filteredPhones.value;
	};

	const filteredPhones = computed(() => {
		const searchTerm = search.value.toLowerCase();
		return No_change_phone_list.value.filter(phone => {
			const hasInstanceName = phone.instance_name && phone.instance_name.toLowerCase().includes(searchTerm);
			const hasInstancesName = phone.instances && phone.instances.name && phone.instances.name.toLowerCase().includes(searchTerm);
			return hasInstanceName || hasInstancesName;
		});
	});

	const selectedPhones = computed(() => phoneList.value.filter(phone => phone.checked));
	const showInfoToggle = computed(() => windowWidth.value < 800);

	interface ApiResponse<T = any> {
		code : number;
		msg : string;
		data : T;
	}
	//获取云手机列表数据
	const fetchPhoneList = async () => {
		try {
			loading.value = true;
			const response = await request.get<ApiResponse<Phone[]>>('/containers/list');
			if (response.data.code === 200) {
				No_change_phone_list.value = response.data.data.map(phone => ({
					...phone,
					checked: false,
					screen_shot_loading: phone.state == 0 ? true : false
				}));
				phoneList.value = filteredPhones.value;
				previewPhoneList.value = response.data.data.map(phone => ({
					...phone,
					checked: Phone_selectedMap_right.value.get(phone.id) ?? false,
					edit_name_checked: false,
					preview_image: phone.screen_shot.includes('http') ? phone.screen_shot + `?timestamp=${Date.now()}` : store.state.request_url + phone.screen_shot + `?timestamp=${Date.now()}`,
					screen_shot_loading: phone.state == 0 ? true : false
				}));
			} else {
				ElMessage.error(response.data.msg || '获取云手机列表失败');
			}
		} catch (error) { } finally {
			loading.value = false;
		}
	};
	//修改云机名称
	const edit_phone_name = async (phone_data : any) => {
		phone_data.edit_name_checked = !phone_data.edit_name_checked
		await nextTick();
		const inputSelector = `.phoneInput_${phone_data.id}`;
		const inputEl = document.querySelector<HTMLInputElement>(inputSelector);
		if (phone_data.edit_name_checked == false) {
			enter_edit_phone_name(phone_data, 'enter')
		} else {
			inputEl?.focus()
		}
	};
	//回车或者失焦修改名称
	const enter_edit_phone_name = (phone_data : any, type : any) => {
		if (type == 'enter') {
			enter_change_flag.value = true
		} else {
			if (enter_change_flag.value == true) {
				enter_change_flag.value = false
				return;
			} else {
				enter_change_flag.value = false
			}
		}
		if (phone_data.instance_name.length > 10) {
			ElMessage.warning('云机名称最多不能超过10个字符');
		} else {
			const requestData = { instance_use_id: phone_data.id, name: phone_data.instance_name };
			const response = request.post('/instance/rename', requestData);
			response.then((res) => {
				if (res.data.code == 200) {
					phone_data.edit_name_checked = false
					ElMessage.success('修改云机名称成功');
				}
			})
		}
	};
	const getRemainingDaysColor = (phone : any) : string => {
		// 修复点5：修正属性名（expire_time 而非 expireTime）
		const expireDate = new Date(phone.expire_time);
		const now = new Date();
		const diffTime = expireDate.getTime() - now.getTime();
		const days = Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
		if (days <= 1) return 'red';
		if (days <= 3) return 'orange';
		return '#909399';
	};

	const formatDate = (dateString : string) : string => {
		if (!dateString) return '';
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return 'Invalid Date';
		return date.toLocaleString('zh-CN', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
			timeZone: 'Asia/Shanghai'
		}).replace(/\//g, '-');
	};

	const isSingleSelected = (phone : Phone) => selectedDevicesCountInCurrentType.value === 1 && phone.checked;

	const selectPhone = (phone : Phone) => {
		phone.checked = !phone.checked;
		Phone_selectedMap.value.set(phone.id, !phone.checked);
	};

	const selectPhone_right = (phone : Phone) => {
		phone.checked = !phone.checked;
		Phone_selectedMap_right.value.set(phone.id, !phone.checked);
	};
	const showPhoneOverlay = async (phone : any) => {
		await new Promise<void>((resolve) => {
			currentPhone.value = phone;
			resolve();
		});
		const index = previewPhoneList.value.findIndex(item => item.id === phone.id);
		if (phone.state == 0) {
			previewPhoneList.value[index].screen_shot_loading = true;
		} else if (phone.state == 1) {
			initPhone(phone, 800);
		} else {
			previewPhoneList.value[index].screen_shot_loading = false;
			ElMessage.error('该云手机目前处于离线状态');
		}
		showInfoPanel.value = windowWidth.value >= 800;
	};

	const isUserActive = ref(true);
	const hoverdada = () => {
		if (restartPhone_loading_text.value == '断流待机中' && restartPhone_loading.value) {
			close_out.value = null;
			restartPhone_loading.value = false;
			initPhone(currentPhone.value, 800);
		}
	};

	const handleActivityChange = (active : boolean) => {
		isUserActive.value = active;
		if (!active) {
			restartPhone_loading.value = true;
			restartPhone_loading_text.value = '断流待机中';
			closeOverlay(true);
		}
	};

	watch(() => store.state.Horizontal_screen, (newvalue) => {
		if (newvalue) {
			document.documentElement.style.setProperty('--zoomsize', '0.8');
		} else {
			document.documentElement.style.setProperty('--zoomsize', `${setCloudPhoneZoom()}`);
		}
	});

	const initPhone = (phone : any, time : any) => {
		if (!phone.instances.machine || !phone.instances.adb_port) {
			ElMessage.error('该云手机实例信息不完整');
			return;
		}
		const udid = `${phone.instances.machine.ip}:${phone.instances.adb_port}`;
		const wsUrl = `wss://${process.env.VUE_APP_API_WS_URL}?action=proxy-adb&remote=tcp:8886&udid=${udid}`;
		parsedQuery.set("action", "stream");
		parsedQuery.set("player", "mse");
		parsedQuery.set("udid", udid);
		parsedQuery.set("hostname", "ws.jtcloud.icu");
		parsedQuery.set("ws", wsUrl);
		parsedQuery.set("port", '10443');
		parsedQuery.set("secure", "true");
		StreamClientScrcpy_start.value = StreamClientScrcpy.start(parsedQuery, undefined, undefined, undefined, undefined, true, true);
		StreamClientScrcpy_start.value.setIdleThreshold(240000);
		StreamClientScrcpy_start.value.addActivityListener(handleActivityChange);
		const player = StreamClientScrcpy_start.value?.getPlayer();
		const checkbox = document.getElementById(`input_capture_keyboard_${udid}_${player?.getName()}`) as HTMLInputElement | null;
		if (checkbox) {
			checkbox.checked = false;
			checkbox.dispatchEvent(new Event('change'));
		}
		setTimeout(() => {
			if (store.state.Phone_Local_keyboard_flag) {
				const toggleBtn = document.getElementById(`input_capture_keyboard_${udid}_${player?.getName()}`);
				if (toggleBtn) {
					toggleBtn.dispatchEvent(new MouseEvent('click', {
						bubbles: true,
						cancelable: true
					}));
				}
			}
		}, 800);
		if (player) {
			setTimeout(() => {
				if (player.videoWidth > player.videoHeight) {
					store.commit('change_screen', true);
					document.documentElement.style.setProperty('--zoomsize', '0.8');
				} else {
					store.commit('change_screen', false);
					document.documentElement.style.setProperty('--zoomsize', `${setCloudPhoneZoom()}`);
				}
				showOverlay.value = true;
			}, time);
			player.touchableCanvas.onclick = () => {
				setTimeout(() => {
					if (!store.state.Horizontal_screen && player.videoWidth > player.videoHeight) {
						store.commit('change_screen', true);
					}
					if (store.state.Horizontal_screen && player.videoWidth < player.videoHeight) {
						store.commit('change_screen', false);
					}
				}, 1000);
			};
		} else {
			ElMessage.error('该云手机实例生成出错,不存在该云机实例');
		}
	};
	//关闭云手机渲染操作弹窗
	const closeOverlay = (flag : any) => {
		if (flag == false) {
			showOverlay.value = false;
			cascader_value.value = [];
		}
		if (ws.value) {
			if (ws.value.readyState === WebSocket.OPEN) {
				ws.value.close(1000, '正常关闭');
			}
			ws.value = null;
		}
		if (StreamClientScrcpy_start.value) {
			warningMessage.value?.close();
			StreamClientScrcpy_start.value.onDisconnected();
			StreamClientScrcpy_start.value.removeActivityListener(handleActivityChange);
			StreamClientScrcpy_start.value.destroy();
			StreamClientScrcpy_start.value = null;
			store.commit('change_screen', false);
		}
		clearImeEvents();
	};
	//单个云手机续费
	const renewPhone = (Phone : any) => {
		const skip_value = { deviceId: [Phone.id], is_realphone: Phone.instances.is_realphone, tab: 'second' };
		router.push('/purches/' + encodeURIComponent(JSON.stringify(skip_value)));
	};
	//批量续费云手机
	const batchRenew = () => {
		const selected = phoneList.value.filter(phone => phone.checked);
		if (selected.length === 0) {
			ElMessage.warning('请先选择云手机');
			return;
		}
		const skip_value = { deviceId: selected.map(phone => phone.id), is_realphone: phoneList.value[0].instances.is_realphone, tab: 'second' };
		router.push('/purches/' + encodeURIComponent(JSON.stringify(skip_value)));
	};
	//购买云手机(跳转云手机页面)
	const addNewPhone = () => {
		router.push('/purches/0');
	};
	//重启云手机
	const restartPhone = () => {
		const requestData = { instance_id: currentPhone.value.id };
		const response = request.post('/containers/restart', requestData);
		const response2 = request.post('/containers/info', requestData);
		restartPhone_loading.value = true;
		restartPhone_loading_text.value = '云手机重启中,请稍等';
		closeOverlay(true);
		response.then(() => {
			var loading_val = setInterval(() => {
				response2.then((res2) => {
					if (res2.data.data.status == 1) {
						clearInterval(loading_val);
						setTimeout(() => {
							initPhone(currentPhone.value, 1000);
							restartPhone_loading.value = false;
						}, 6000);
					}
				});
			}, 1000);
		});
	};

	const shutdownPhone = () => {
		ElMessageBox.confirm(
			'一键新机将清空云机内数据，是否确认重置?',
			'警告',
			{
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
			}
		)
			.then(async () => {
				const requestData = { instance_use_id: currentPhone.value.id };
				restartPhone_loading.value = true;
				restartPhone_loading_text.value = '云手机重启中,请稍等';
				closeOverlay(true);
				await request.post('/realphone/easy_recreate', requestData);
				await new Promise(resolve => setTimeout(resolve, 5000));
				await pollContainerInfo(currentPhone.value.id, {
					interval: 5000,
					maxAttempts: 10,
					onProgress: (attempt) => { console.log(`第${attempt}次轮询`); }
				});
				setTimeout(() => {
					initPhone(currentPhone.value, 1000);
				}, 6000);
				restartPhone_loading.value = false;
			})
			.catch(() => { })
	};

	const restart_All_Phone = async () => {
		const selected_data = previewPhoneList.value.filter(phone => phone.checked);
		if (selected_data.length > 0) {
			const requestData = { instance_use_ids: selected_data.map(item => item.id) };
			request.post('/containers/batch_restart', requestData).then(() => {
				ElMessage.success('云手机重启中');
				fetchPhoneList();
			}).catch(() => { });
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};

	const reset_All_Phone = async () => {
		const selected_data = previewPhoneList.value.filter(phone => phone.checked);
		if (selected_data.length > 0) {
			ElMessageBox.confirm(
				'重置云机将清空云机内数据，是否确认重置?',
				'警告',
				{
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					const requestData = { instance_use_ids: selected_data.map(item => item.id) };
					request.post('/containers/batch_reset', requestData).then(() => {
						ElMessage.success('云手机重启中');
						fetchPhoneList();
					}).catch(() => { });
				})
				.catch(() => { })
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};
	//群体一键新机
	const shutdown_All_Phone = async () => {
		const selected_data = previewPhoneList.value.filter(phone => phone.checked);
		if (selected_data.length > 0) {
			ElMessageBox.confirm(
				'一键新机将清空云机内数据，是否确认重置?',
				'警告',
				{
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					const requestData = { instance_use_ids: selected_data.map(item => item.id) };
					request.post('/realphone/batch_easy_recreate', requestData).then(() => {
						ElMessage.success('云手机重启中');
						fetchPhoneList();
					}).catch(() => { });
				})
				.catch(() => { })
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};
	//更换机型弹窗根据安卓版本选中的云手机列表
	const handleSelectionChange = (val : any[]) => {
		android_selectedPhones.value = val;
	};

	// 1. 添加 checkSelectable 方法
	const checkSelectable = (row : Phone) => {
		// 如果 instances.is_realphone 为 0，则禁用选择
		return row.instances?.is_realphone === 1;
	};

	const getRowClass = ({ row }: { row: Phone; rowIndex: number }) => {
		if (row?.instances?.is_realphone === 0) {
			return 'disabled-row';
		}
		return '';
	};

	const getCellClass = ({ row }: { row: Phone; rowIndex: number }) => {
		if (row?.instances?.is_realphone === 0) {
			return 'disabled-cell';
		}
		return '';
	};

	//群体更换机型弹窗开关
	const change_phone_model_dialog_show = async (item : AndroidVersionGroup) => {
		try {
			const res = await request.get(`/realphone/list?android_version=${item.android_version}`);
			res.data.data.forEach((item : any, index : number) => {
				res.data.data[index] = { ...item, model: item.brand, id: index };
			});
			phone_type_list.value = res.data.data;
			current_android_phone_tableData.value = item.phones_arr;
			current_android_version.value = item.android_version;

			// 等待 DOM 更新
			await nextTick();

			// 自动勾选 checked 为 true 且 is_realphone 为 1 的行
			if (phoneTableRef.value) {
				// 先清除所有选择
				phoneTableRef.value.clearSelection();

				// 只勾选 checked 为 true 且 is_realphone 为 1 的行
				current_android_phone_tableData.value.forEach((row : Phone) => {
					if (row.checked && row.instances?.is_realphone === 1) {
						phoneTableRef.value.toggleRowSelection(row, true);
					}
				});
			}

			// 最后再显示对话框
			change_phone_model_visible.value = true;
		} catch (error) {
			console.error('请求失败:', error);
		}
	};
	//把云手机列表按安卓版本进行分类处理
	const android_classify_phone = async () => {
		// 按安卓版本分组
		const groupedArray = previewPhoneList.value.reduce((result : any[], currentItem : any) => {
			const tag = currentItem.image_tag;
			let tagGroup = result.find((group : AndroidVersionGroup) => group.android_version === tag);

			if (!tagGroup) {
				tagGroup = {
					android_version: tag,
					phones_arr: []
				};
				result.push(tagGroup);
			}

			tagGroup.phones_arr.push(currentItem);
			return result;
		}, []);
		// 对分组进行排序：按安卓版本号（字符串转数字）
		groupedArray.sort((a : any, b : any) => {
			// 提取版本号数字，处理可能的小数点
			const versionA = parseFloat(a.android_version) || 0;
			const versionB = parseFloat(b.android_version) || 0;
			return versionB - versionA; // 降序排列（高版本在前）
		});
		// 对每个分组内的phones_arr进行排序：checked为true的在前
		groupedArray.forEach((group : any) => {
			group.phones_arr.sort((a : any, b : any) => {
				// 如果a.checked为true，b.checked为false，则a在前
				if (a.checked && !b.checked) return -1;
				// 如果a.checked为false，b.checked为true，则b在前
				if (!a.checked && b.checked) return 1;
				// 其他情况保持原顺序
				return 0;
			});
		});
		android_classify_phone_list.value = groupedArray;
		change_phone_model_dialog_show(android_classify_phone_list.value[0]);
	};
	// 添加一个安全的方法来处理 row-key
	const getRowKey = (row : Phone) => {
		if (!row) return 'empty-row-key';
		return row.instance_id || row.id || Math.random().toString();
	};
	//按照安卓品牌更换机型时 选择品牌
	const select_brands = (value : string) => {
		const foundItem = phone_type_list.value.find(item => item.brand === value);
		// 类型断言改为符合 ModelOption 类型
		select_model_list.value = (foundItem ? foundItem.models : []) as ModelOption[];
	}
	//群体更换机型方法
	const check_All_phone_type = async () => {
		if (!select_brand_value.value || !select_model_value.value) {
			ElMessage.warning('请先选择云机品牌和机型');
			return;
		}
		if (android_selectedPhones.value.length > 0) {
			const requestData = {
				model_id: select_model_value.value,
				instance_use_ids: android_selectedPhones.value.map(item => item.id),
				clear_data: reset_phone_data_checked.value ? 'true' : 'false'
			};
			restartPhone_loading.value = true;
			request.post('/realphone/batch_change_model', requestData).then(() => {
				ElMessage.success('云手机重启中');
				change_phone_model_visible.value = false
				fetchPhoneList();
			}).catch(() => { });
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};

	const pollRequest = async <T>(
		requestFn : () => Promise<any>,
		checkFn : (response : any) => boolean,
		options : { interval ?: number; maxAttempts ?: number; onProgress ?: (attempt : number, response : any) => void; } = {}
	) : Promise<T> => {
		const { interval = 5000, maxAttempts = 10, onProgress } = options;
		let attempts = 0;
		const poll = async () : Promise<T> => {
			attempts++;
			try {
				const response = await requestFn();
				if (onProgress) onProgress(attempts, response);
				if (checkFn(response)) return response;
				else if (attempts >= maxAttempts) throw new Error(`轮询达到最大次数 (${maxAttempts})`);
				else {
					await new Promise(resolve => setTimeout(resolve, interval));
					return poll();
				}
			} catch (error) {
				if (attempts >= maxAttempts) throw error;
				else {
					await new Promise(resolve => setTimeout(resolve, interval));
					return poll();
				}
			}
		};
		return poll();
	};

	const pollContainerInfo = (
		instanceId : number,
		options : { interval ?: number; maxAttempts ?: number; onProgress ?: (attempt : number, response : any) => void; } = {}
	) => {
		const requestFn = () => request.post('/containers/info', { instance_id: instanceId });
		const checkFn = (response : any) => response.data.data.state === 1;
		return pollRequest(requestFn, checkFn, options);
	};
	//单云机重置
	const resetPhone = () => {
		ElMessageBox.confirm(
			'重置云机将清空云机内数据，是否确认重置?',
			'警告',
			{
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
			}
		)
			.then(() => {
				const requestData = { instance_id: currentPhone.value.id };
				const response = request.post('/containers/batch_reset', requestData);
				const response2 = request.post('/containers/info', requestData);
				restartPhone_loading.value = true;
				restartPhone_loading_text.value = '云手机重置并重启中,请稍等';
				closeOverlay(true);
				response.then(() => {
					var loading_val = setInterval(() => {
						response2.then((res2) => {
							if (res2.data.data.status == 1) {
								clearInterval(loading_val);
								setTimeout(() => {
									initPhone(currentPhone.value, 1000);
									restartPhone_loading.value = false;
								}, 6000);
							}
						});
					}, 1000);
				});
			})
			.catch(() => { })
	};

	const change_phone_type = (type : any) => {
		request.get(`/realphone/list?android_version=${currentPhone.value.image_tag}`).then((res) => {
			res.data.data.forEach((item : any, index : any) => {
				res.data.data[index] = { ...item, model: item.brand, id: index };
			});
			phone_type_list.value = res.data.data;
			phone_type_cascader_show.value = true
		});
	};

	const check_phone_type = async (value : any) => {
		var requestData = {
			model_id: value[value.length - 1],
			instance_use_id: currentPhone.value.id
		};
		restartPhone_loading.value = true;
		restartPhone_loading_text.value = '云手机重启中,请稍等';
		phone_type_popoverRef.value?.hide()
		closeOverlay(true);
		try {
			await request.post('/realphone/change_model', requestData);
			await new Promise(resolve => setTimeout(resolve, 5000));
			await pollContainerInfo(currentPhone.value.id, {
				interval: 5000,
				maxAttempts: 10
			});
			setTimeout(() => {
				initPhone(currentPhone.value, 1000);
			}, 6000);
			restartPhone_loading.value = false;
		} catch (error) {
			restartPhone_loading.value = false;
			phone_type_popoverRef.value?.hide()
			throw error;
		}
	};

	const polling_containers_info = () => {
		const containers_info = { instance_id: currentPhone.value.id };
		request.post('/containers/info', containers_info).then((res2) => {
			if (res2.data.data.status == 1) {
				clearInterval(loading_phone_info.value);
				setTimeout(() => {
					initPhone(currentPhone.value, 1000);
					restartPhone_loading.value = false;
				}, 5000);
			}
		});
	};

	const handleResize = () => {
		windowWidth.value = window.innerWidth;
		if (windowWidth.value >= 800 && !showInfoPanel.value) {
			showInfoPanel.value = true;
		}
		if (window.innerWidth < 800) {
			elementWidth.value = '100%';
			elementWidthflag.value = false;
		} else {
			elementWidth.value = 'auto';
			elementWidthflag.value = true;
		}
	};

	const initPlayers = async (zoomsize : any) => {
		const { MsePlayer } = await import('@/app/player/MsePlayer');
		StreamClientScrcpy.registerPlayer(MsePlayer);
		const { WebCodecsPlayer } = await import('@/app/player/WebCodecsPlayer');
		StreamClientScrcpy.registerPlayer(WebCodecsPlayer);
		MsePlayer.resize(880, 1920, zoomsize, 5388608);
	};
	//根据当前电脑分辨率计算出当前云手机屏幕的缩放比例
	function setCloudPhoneZoom() {
		var zoomsize = 0.4
		var screen_width = window.screen.width
		if (screen_width > 1920) {
			zoomsize = 0.4 + (Math.floor((screen_width - 1920) / 96) * 0.01)
		} else if (screen_width < 1920) {
			zoomsize = 0.4 - (Math.floor((1920 - screen_width) / 96) * 0.01)
		} else {
			zoomsize = 0.4
		}
		return zoomsize;
	}
	onMounted(async () => {
		const zoom = setCloudPhoneZoom();
		await initPlayers(zoom);
		window.addEventListener('resize', handleResize);
		fetchPhoneList();
	});

	onUnmounted(() => {
		if (StreamClientScrcpy_start.value) {
			StreamClientScrcpy_start.value.removeActivityListener(handleActivityChange);
			StreamClientScrcpy_start.value.destroy();
		}
		if (fetchPhoneList_Interval.value) {
			clearInterval(fetchPhoneList_Interval.value);
			fetchPhoneList_Interval.value = null;
		}
		window.removeEventListener('resize', handleResize);
		clearImeEvents();
	});

	interface CommitMsg { type : 'commit'; text ?: string; }
	interface DeleteMsg { type : 'delete'; count : number; text ?: string; }
	interface ReplaceMsg { type : 'replace'; text ?: string; }
	type InputMsg = CommitMsg | DeleteMsg | ReplaceMsg;
	const imeRef = ref<HTMLInputElement | null>(null);
	const imeRef2 = ref<HTMLInputElement | null>(null);
	let lastSent = "";
	let isEventsBound = false;
	let keyInputListener : KeyEventListener | null = null;
	let isComposing = ref(false);
	function sendMsg(msg : InputMsg) : void {
		const currentPhone_udid = `${currentPhone.value.instances.machine.ip}:${currentPhone.value.instances.adb_port}`;
		const requestData = { udid: currentPhone_udid, text: msg.text };
		request.post('/containers/transfer_text', requestData).then(() => {
			if (!isComposing.value) {
				KeyInputHandler.setWebSocketEnabled(true);
			}
		}).catch(() => { });
	}
	const imeRef_focus = () => {
		if (store.state.Phone_Local_keyboard_flag) {
			imeRef.value?.focus()
		} else {
			imeRef2.value?.focus()
		}
	}
	const handleCompositionStart = (e : Event) => {
		const ev = e as CompositionEvent;
		isComposing.value = true;
		KeyInputHandler.setWebSocketEnabled(false);
		e.stopImmediatePropagation();
		e.preventDefault();
	};

	const handleCompositionEnd = (e : Event) => {
		const ev = e as CompositionEvent;
		const chineseText = ev.data?.trim();
		setTimeout(() => {
			isComposing.value = false;
			KeyInputHandler.setWebSocketEnabled(true);
		}, 100);

		if (chineseText && store.state.Phone_Local_keyboard_flag && imeRef.value) {
			const msg : CommitMsg = { type: 'commit', text: chineseText };
			sendMsg(msg);
			imeRef.value.value = "";
			lastSent = "";
		}
	};

	const handleInput = (e : Event) => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		const inputEvent = e as InputEvent;
		const newValue = imeRef.value.value;

		if (isComposing.value) {
			return;
		}
		if (newValue.length > lastSent.length) {
			const newChars = newValue.slice(lastSent.length);

			for (const char of newChars) {
				if (char === '?' || char === '/') {
					sendSymbolAsText(char);
					continue;
				}
				if (char >= ' ' && char <= '~') {
					KeyInputHandler.sendCharacter(char);
					console.log('前端传递字符到 sendCharacter:', char);
				}
			}
			lastSent = newValue;
		}
		else if (newValue.length < lastSent.length) {
			lastSent = newValue;
		}
	};
	const sendSymbolAsText = (symbol : string) => {
		if (!currentPhone.value?.instances?.machine || !currentPhone.value?.instances?.adb_port) {
			ElMessage.error('云手机信息不完整，无法发送符号');
			return;
		}
		const currentPhoneUdid = `${currentPhone.value.instances.machine.ip}:${currentPhone.value.instances.adb_port}`;
		const requestData = {
			udid: currentPhoneUdid,
			text: symbol
		};
		request.post('/containers/transfer_text', requestData)
			.then(() => { })
			.catch(() => { });
	};

	const handleKeyDown = (e : KeyboardEvent) => {
		if (!store.state.Phone_Local_keyboard_flag || isComposing.value) return;
		if (e.key === 'CapsLock') {
			e.preventDefault();
			KeyInputHandler.sendKeyEvent(e.code, 'down', 0);
			return;
		}

		if (e.key === 'Backspace') {
			e.preventDefault();
			KeyInputHandler.sendBackspaceKey();
			return;
		}

		const functionKeys = [
			'Enter', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown',
			'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
		];

		if (functionKeys.includes(e.key)) {
			e.preventDefault();
			const metaState = e.shiftKey ? 1 : 0;
			KeyInputHandler.sendKeyEvent(e.code, 'down', metaState);
		}
	};

	const handleKeyUp = (e : KeyboardEvent) => {
		if (isComposing.value || !store.state.Phone_Local_keyboard_flag) {
			e.stopPropagation();
			e.preventDefault();
			return;
		}

		if (e.key === 'CapsLock') {
			e.preventDefault();
			KeyInputHandler.sendKeyEvent(e.code, 'up', 0);
			return;
		}

		const functionKeys = [
			'Enter', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown',
			'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
		];

		if (functionKeys.includes(e.key)) {
			e.preventDefault();
			const metaState = e.shiftKey ? 1 : 0;
			KeyInputHandler.sendKeyEvent(e.code, 'up', metaState);
		}
	};
	const handlePaste = (e : Event) => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		const ev = e as ClipboardEvent;
		ev.preventDefault();
		const pastedText = ev.clipboardData?.getData('text');
		if (pastedText) {
			let pastedTexted : string = pastedText
			StreamClientScrcpy_start.value?.sendMessage(CommandControlMessage.createSetClipboardCommand(pastedTexted))
			imeRef.value.value = "";
		}
	};
	const handlePaste2 = (e : Event) => {
		if (store.state.Phone_Local_keyboard_flag || !imeRef2.value) return;
		const ev = e as ClipboardEvent;
		ev.preventDefault();
		const pastedText = ev.clipboardData?.getData('text');
		if (pastedText != "" && pastedText != undefined) {
			let pastedTexted : string = pastedText
			StreamClientScrcpy_start.value?.sendMessage(CommandControlMessage.createSetClipboardCommand(pastedTexted))
		}
	};

	const handleFocus = (e : Event) => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		lastSent = imeRef.value.value;
	};

	const handleBlur = (e : Event) => {
		isComposing.value = false;
		KeyInputHandler.setWebSocketEnabled(true);
	};
	const bindImeEvents = () => {
		const inp = imeRef.value;
		if (!inp || !store.state.Phone_Local_keyboard_flag || isEventsBound) return;
		inp.addEventListener('input', handleInput);
		inp.addEventListener('keydown', handleKeyDown);
		inp.addEventListener('compositionstart', handleCompositionStart);
		inp.addEventListener('compositionend', handleCompositionEnd);
		inp.addEventListener('keyup', handleKeyUp);
		inp.addEventListener('paste', handlePaste);
		inp.addEventListener('focus', handleFocus);
		inp.addEventListener('blur', handleBlur);
		keyInputListener = {
			onKeyEvent: (message) => {
				if (ws.value && ws.value.readyState === WebSocket.OPEN) {
					ws.value.send(JSON.stringify(message));
				}
			}
		};
		KeyInputHandler.addEventListener(keyInputListener);
		isEventsBound = true;
		inp.focus();
		setTimeout(() => inp.focus(), 100);
	};
	const bindImeEvents2 = () => {
		const inp = imeRef2.value;
		if (!inp || store.state.Phone_Local_keyboard_flag || isEventsBound) return;
		inp.addEventListener('paste', handlePaste2);
		setTimeout(() => inp.focus(), 100);
	};
	const clearImeEvents = () => {
		const inp = imeRef.value;
		if (!inp || !isEventsBound) return;
		inp.removeEventListener('keydown', handleKeyDown);
		inp.removeEventListener('input', handleInput);
		inp.removeEventListener('compositionstart', handleCompositionStart);
		inp.removeEventListener('compositionend', handleCompositionEnd);
		inp.removeEventListener('keyup', handleKeyUp);
		inp.removeEventListener('paste', handlePaste);
		inp.removeEventListener('focus', handleFocus);
		inp.removeEventListener('blur', handleBlur);
		if (keyInputListener) {
			KeyInputHandler.removeEventListener(keyInputListener);
			keyInputListener = null;
		}

		isEventsBound = false;
		isComposing.value = false;
		lastSent = "";
		inp.value = "";
	};

	const clearImeEvents2 = () => {
		const inp = imeRef2.value;
		if (!inp) return;

		inp.removeEventListener('paste', handlePaste);

		inp.value = "";
	};

	watch(() => showOverlay.value, (isShow) => {
		if (isShow && store.state.Phone_Local_keyboard_flag) {
			bindImeEvents();
			clearImeEvents2()
		} else {
			clearImeEvents();
			bindImeEvents2()
		}
	}, { immediate: true });

	watch(() => store.state.Phone_Local_keyboard_flag, (isEnabled) => {
		const inp = imeRef.value;
		if (!inp) return;
		if (isEnabled && showOverlay.value) {
			bindImeEvents();
			clearImeEvents2()
		} else {
			clearImeEvents()
			bindImeEvents2();
			inp.value = "";
			isComposing.value = false;
			KeyInputHandler.setWebSocketEnabled(true);
		}
	}, { immediate: true });
	watch(() => store.state.orientation, (orientation) => {
		console.log('wahted orientation', orientation);
		if (StreamClientScrcpy_start.value) {
			StreamClientScrcpy_start.value.destroy();
			StreamClientScrcpy_start.value?.player?.stop()
			StreamClientScrcpy_start.value?.streamReceiver.destroy()
		}
		initPhone(currentPhone.value, 10)
	})
</script>

<style lang="less" scoped>
	.fun_options {
		p {
			margin: 0;
			padding: 10px 0 10px 20px;

			&:hover {
				background-color: rgb(235.9, 245.3, 255);
				color: #409eff;
				cursor: pointer;
			}
		}
	}
	:deep(.disabled-row) {
	    background-color: #f5f5f5;
	    color: #999;
	}
	
	:deep(.disabled-row .el-checkbox__inner) {
	    background-color: #f5f5f5;
	    border-color: #dcdfe6;
	    cursor: not-allowed;
	}
	
	:deep(.disabled-row .el-checkbox__input.is-disabled .el-checkbox__inner) {
	    background-color: #f5f5f5;
	    border-color: #dcdfe6;
	}
	
	:deep(.disabled-cell) {
	    color: #999 !important;
	}
	.android-tabs-header {
		display: flex;
		border-bottom: 1px solid #e0e0e0;
	}

	.android-tab-item {
		padding: 12px 24px;
		cursor: pointer;
		font-size: 14px;
		color: #666;
		transition: all 0.3s ease;
		position: relative;
	}

	.android-tab-item:hover {
		color: #3964fe;
	}

	.android-tab-item.active {
		color: #3964fe;
		font-weight: 500;
	}
	
	/* 底部蓝色边框 */
	.android-tab-item.active::after {
		content: '';
		position: absolute;
		left: 0;
		bottom: -1px;
		width: 100%;
		height: 2px;
		background-color: #3964fe;
		border-radius: 1px 1px 0 0;
	}

	.phone-android-version-view {
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;

		div {
			display: flex;
			align-items: center;
		}

		img {
			width: 20px !important;
			height: 20px !important;
		}
	}

	.android-version-view {
		margin-left: 10px;
		margin-right: 10px;
		border-top: 1px solid #999;
	}

	.android-version-view:nth-of-type(1) {
		border: none;
	}

	:deep(.function_btns .el-descriptions-item__content) {
		margin-left: 0 !important;
		padding-left: 0 !important;
	}

	.function_btns {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}

	:deep(.el-descriptions__body) {
		--el-descriptions-item-bordered-label-width: 0px;
	}

	.main_container {
		width: 100%;
		display: grid;
		grid-template-columns: repeat(8, 11.5%);
		justify-content: space-between;
		column-gap: 0.5%;
		row-gap: 2%;

		>div {
			min-width: 100%;
			height: 150px;

			img {
				width: 100%;
				height: auto;
				object-fit: contain;
			}
		}
	}

	/deep/ .phone-display {
		zoom: var(--zoomsize);
	}

	:deep(.phone-display .el-loading-spinner) {
		zoom: 2.4;
	}

	:deep(.more-box) {
		zoom: 2.4;
	}

	.left_box {
		background: #f0f3f5;

		:deep(.el-card__body) {
			padding: 10px;
		}
	}

	.select-all {
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.compact-rectangle .logo {
		font-size: 20px;
		font-weight: bold;
		padding: 20px;

	}

	.compact-rectangle .phone_name_box {
		display: flex;
		justify-content: flex-end;
		align-items: center;

		input {
			width: 80%;
			height: 20px;
			margin-bottom: 10px;
			border: none;
			border-bottom: 1px solid #aaa;
		}

	}

	.header-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #f5f7fa;
		padding: 10px 20px;
		border-bottom: 1px solid #ebeef5;
	}

	.top-right-buttons {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 10px;
	}

	.text-center {
		text-align: center;
		margin-top: 10px;
	}

	.mt-3 {
		margin-top: 15px;
	}

	.overlay-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 2000;
		display: flex;
		justify-content: flex-end;
	}

	.overlay-container {
		height: 100%;
		background: white;
		position: relative;
	}

	.close-icon {
		position: absolute;
		top: 20px;
		right: 20px;
		font-size: 24px;
		cursor: pointer;
		z-index: 2001;
	}

	.overlay-content {
		display: flex;
		height: 100%;
	}

	.phone-display {
		flex: 1;
		padding: 20px;
		background: #f5f7fa;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	/deep/ .device-view {
		display: flex !important;
		flex-direction: row-reverse;
		flex-wrap: nowrap !important;
	}

	/deep/ .control-buttons-list {
		svg {
			width: 84px;
			height: 84px;

			&:hover {
				cursor: pointer;
			}
		}
	}

	.phone-info {
		width: 350px;
		background: #fff;
		border-radius: 4px;
		padding: 0;
		overflow: hidden;
		margin: 0 20px;

		h3 {
			margin: 0;
			padding: 16px;
			color: #303133;
			font-size: 16px;
			font-weight: 600;
			border-bottom: 1px solid #dcdfe6;
		}
	}

	.info-container {
		display: flex;
		flex-direction: column;
	}

	.info-row {
		display: flex;
		align-items: stretch;
		border-bottom: 1px solid #dcdfe6;

		&:last-child {
			border-bottom: none;
		}
	}

	.info-label {
		width: 100px;
		padding: 12px;
		color: #606266;
		font-size: 14px;
		font-weight: 500;
		flex-shrink: 0;
		background-color: #f5f7fa;
		border-left: 1px solid #dcdfe6;
		border-right: 1px solid #dcdfe6;
		display: flex;
		align-items: center;
	}

	.info-value {
		flex: 1;
		padding: 12px;
		color: #303133;
		font-size: 14px;
		display: flex;
		align-items: center;
		border-right: 1px solid #dcdfe6;
	}

	.status-tag {
		display: inline-block;
		padding: 0 10px;
		height: 24px;
		line-height: 24px;
		font-size: 12px;
		border-radius: 4px;
		box-sizing: border-box;
		white-space: nowrap;

		&.running {
			background-color: #f0f9eb;
			color: #67c23a;
			border: 1px solid #e1f3d8;
		}

		&.stopped {
			background-color: #fef0f0;
			color: #f56c6c;
			border: 1px solid #fde2e2;
		}
	}

	.action-row {
		box-sizing: border-box;
		padding: 10px 0;
		border-left: 1px solid #dcdfe6;
		border-right: 1px solid #dcdfe6;
		border-bottom: 1px solid #dcdfe6;
	}

	.action-buttons {
		padding: 16px;
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}

	@media (max-width: 800px) {
		.phone-info {
			position: absolute;
			right: 0;
			top: 0;
			bottom: 0;
			width: 350px;
			background: white;
			box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
			transform: translateX(0);
			z-index: 1;

			&.hidden {
				transform: translateX(100%);
			}
		}

		.info-row {
			flex-direction: column;
			align-items: flex-start;
			gap: 4px;
		}

		.info-label {
			width: 100%;
		}

		.action-row {
			flex-direction: column;
		}

		.action-row .el-button {
			width: 100%;
			margin-bottom: 8px;
		}
	}

	@media (max-width: 500px) {
		.phone-display {
			min-width: 100%;
		}
	}

	.info-toggle-btn {
		position: absolute;
		top: 50%;
		right: 10px;
		transform: translateY(-50%);
		z-index: 2;
	}

	.slide-fade-enter-active {
		transition: all 0.3s ease-out;
	}

	.slide-fade-leave-active {
		transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.slide-fade-enter-from,
	.slide-fade-leave-to {
		opacity: 0;
		transform: translateX(100%);
	}

	.compact-container {
		display: flex;
		gap: 4px;
		padding: 0 10px;
	}

	.compact-wrapper {
		width: 50%;
		padding: 0 2px;
	}

	.compact-rectangle {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0;
		background: #ffffff;
		border-radius: 8px;
		border: 1px solid #ebeef5;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
		cursor: pointer;
		transition: all 0.2s;
		overflow: hidden;
		padding: 10px;
		box-sizing: border-box;

		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
		}
	}

	.compact-image-container {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		background: #ffffff;
		padding: 0;
		margin: 0;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.compact-label {
		padding: 6px;
		text-align: center;
		font-size: 12px;
		color: #333;
		border-top: 1px solid #ebeef5;
	}

	.compact-add-btn {
		width: 90%;
		padding: 8px 12px;
		font-size: 12px;
		color: #409EFF;
		border-color: #409EFF;
		background-color: #ffffff;

		&:hover {
			color: #ffffff;
			background-color: #409EFF;
		}
	}
</style>